// @flow

import * as React from 'react';
import { IntlProvider } from 'react-intl';
import { connect } from 'react-redux';

import type { State } from 'store/State';
import {
  getLanguageCode,
  getLocaleCode
} from 'store/reducers/dealerLocale/selectors';
import { getMessages } from 'store/reducers/localizationString/selectors';

type Messages = {
  en?: Object,
  es?: Object,
  de?: Object,
  fr?: Object
};

type Props = {
  /** a language code from the list of possible language codes */
  localeCode: string,
  languageCode: string,
  children: React.Node,
  messages: Messages
};

const LanguageProvider = ({
  children,
  languageCode,
  messages,
  localeCode
}: Props) => {
  return (
    <IntlProvider
      locale={localeCode.replace('_', '-')}
      messages={messages[languageCode]}
      key={localeCode}
    >
      {React.Children.only(children)}
    </IntlProvider>
  );
};

const mapStateToProps = (state: State) => ({
  languageCode: getLanguageCode(state),
  localeCode: getLocaleCode(state),
  messages: getMessages(state)
});

export default connect(mapStateToProps)(LanguageProvider);



// WEBPACK FOOTER //
// ./src/components/common/providers/i18n/LanguageProvider.js